import { render, staticRenderFns } from "./quotationAssignDialog.vue?vue&type=template&id=00d53702"
import script from "./quotationAssignDialog.vue?vue&type=script&lang=js"
export * from "./quotationAssignDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_babel-core@7.0.0-bridge.0_@babel+core@7.0.0_f2752dac7684e9922cbc3a420999c69f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00d53702')) {
      api.createRecord('00d53702', component.options)
    } else {
      api.reload('00d53702', component.options)
    }
    module.hot.accept("./quotationAssignDialog.vue?vue&type=template&id=00d53702", function () {
      api.rerender('00d53702', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cardSystem/saleToos/projectDelivery/components/quotationAssignDialog.vue"
export default component.exports